import { Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  loadingSub: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  readonly isLoading = toSignal(this.loadingSub, { initialValue: false });

  setLoading(loading: boolean): void {
    this.loadingSub.next(loading);
  }
}
